<template>
  <div>
    <HeadGetBackBar v-if="showHeadBar"></HeadGetBackBar>
   <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <ScroolTop ></ScroolTop>
    <!-- <back-link v-if="this.$route.meta.routerBack !== false"></back-link> -->
  </div>
</template>
<script>
import HeadGetBackBar from '@/components/HeadGetBackBar'

// import backLink from '@/components/BackLink/index.vue'
import ScroolTop from '@/components/ScrollTop'

export default {
  components: {
    // backLink
    ScroolTop,
    HeadGetBackBar
  },
  data () {
    return {
      showScrollTop: false
    }
  },
  computed: {
    showHeadBar () {
      const showHeadBar = this.$route.meta.showHeadBar
      return (showHeadBar === undefined || showHeadBar === true)
    }
  },
  activated () {
    if (this.$route.meta.showScrollTop) {
      this.showScrollTop = true
    } else {
      this.showScrollTop = false
    }
  }
  // data () {
  //   return {
  //   }
  // },
}
</script>